/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

import Index from "./Index";

const router = {
  path: "business",
  breadcrumbName: "商机管理",
  childRoutes: [
    {
      path: "list",
      breadcrumbName: "商机列表",
      indexRoute: {
        component: Index,
      },
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/crm/business/router.js